import { Link as RouterLink, LinkProps, useParams } from 'react-router-dom'
import { cn } from '@/lib/utils'

export function Link({ to, className, ...props }: LinkProps) {
  const { lang } = useParams<{ lang: string }>()

  let finalTo = to
  if (typeof to === 'string' && to.startsWith('/')) {
    const langPrefix = lang || 'en'
    finalTo = `/${langPrefix}${to}`
  }

  return (
    <RouterLink
      to={finalTo}
      className={cn('text-[#5696C6] hover:text-[#4580b0]', className)}
      {...props}
    />
  )
}
